import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import CircularLoader from '@base/CircularLoader/CircularLoader';

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: span 10;
  margin: ${Spacings.SPACING_25B} 0px;
`;

const Loader = () => (
  <LoaderContainer>
    <CircularLoader size={30} color="var(--color-i-blue)" />
  </LoaderContainer>
);

export default Loader;
